import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchUserAttributes } from "../../../apis/dashboardApi";
import { Form, Dropdown, FormControl } from "react-bootstrap";

/**
 * CategoryFilter - Reusable category filter dropdown
 * @param {Array} value - Selected values
 * @param {Function} setValue - Setter for selected values
 * @param {Boolean} getAPI - If true, fetch categories from API; if false, use categoryOptions prop
 * @param {Array} categoryOptions - Pre-defined category options to use when getAPI is false
 */
const CategoryFilter = ({
  value,
  setValue,
  getAPI = true,
  categoryOptions: categoryOptionsProps = [],
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const { userInformation } = useSelector((state) => state.UserReducer);
  // Fetch category options from API on mount (only if getAPI is true)
  useEffect(() => {
    if (!getAPI) {
      // Use provided categoryOptions when getAPI is false
      if (categoryOptionsProps && categoryOptionsProps?.length > 0) {
        setCategoryOptions(categoryOptionsProps);
      }
      return;
    }

    const fetchCategories = async () => {
      try {
        const userId = userInformation?.userid || "";
        if (!userId) return;
        const data = await fetchUserAttributes(userId);
        const result = Array.isArray(data?.UserAttributes)
          ? data?.UserAttributes
          : Array.isArray(data)
            ? data
            : [];
        if (result?.length > 0) {
          // Unique Categories
          const uniqueCategories = Array.from(
            new Set(result?.map((item) => item?.Category)?.filter(Boolean)),
          );
          //   setCategoryOptions(uniqueCategories.map((cat) => ({ name: cat, code: cat })));
          if (uniqueCategories?.length > 0) {
            setCategoryOptions(
              uniqueCategories?.map((cat) => ({
                label: cat,
                value: cat,
              })),
            );
          }
        }
      } catch (e) {
        setCategoryOptions([]);
      }
    };
    fetchCategories();
  }, [userInformation, getAPI, categoryOptionsProps]);

  return (
    <div style={{ maxWidth: 220 }}>
      <Form.Group
        className="mb-3"
        controlId="categoryDropdownGroup"
        style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 12 }}
      >
        <Form.Label
          style={{ fontWeight: "bold", minWidth: 40, marginBottom: 0, whiteSpace: "nowrap" }}
        >
          Category
        </Form.Label>
        <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
          <Dropdown.Toggle
            variant="light"
            style={{
              width: "125px",
              textAlign: "left",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              background: "#fff",
              color: "#222",
              border: "1px solid #ced4da",
              boxShadow: "none",
              borderRadius: "5px",
            }}
            title={
              value?.length === 0
                ? "Select Category"
                : categoryOptions
                    .filter((opt) => value?.includes(opt.value))
                    .map((opt) => opt.label)
                    .join(", ")
            }
          >
            <span
              style={{
                display: "inline-block",
                maxWidth: 140,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "middle",
              }}
            >
              {value?.length === 0
                ? "Select Category"
                : categoryOptions?.filter((opt) => value?.includes(opt?.value))?.map((opt) => opt?.label)?.join(", ")}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ width: 180, padding: 8 }}>
            <FormControl
              autoFocus
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                marginBottom: 8,
                background: "#fff",
                color: "#222",
                boxShadow: "none",
                borderColor: "#ced4da",
              }}
            />
            <div style={{ maxHeight: 180, overflowY: "auto", background: "#fff" }}>
              {categoryOptions?.filter((opt) => opt?.label?.toLowerCase()?.includes(search?.toLowerCase()))?.map((opt) => (
                  <Form.Check
                    key={opt.value}
                    type="checkbox"
                    id={`category-filter-${opt.value}`}
                    label={opt.label}
                    checked={value?.includes(opt?.value)}
                    onChange={(e) => {
                      if (e?.target?.checked) {
                        setValue([...value, opt?.value]);
                      } else {
                        setValue(value?.filter((v) => v !== opt?.value));
                      }
                    }}
                    style={{ marginBottom: 4 }}
                  />
                ))}
              {categoryOptions?.filter((opt) => opt?.label?.toLowerCase()?.includes(search?.toLowerCase()))?.length === 0 && <div style={{ color: "#888", padding: 8 }}>No options found</div>}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>
    </div>
  );
};

export default CategoryFilter;
